import { createGlobalStyle } from 'styled-components'
import { ThemeInterface, getBoldFontFamily, getFontFamily } from './theme' // Import your theme interface

const GlobalStyle = createGlobalStyle<{ theme: ThemeInterface }>`
    body {
        font-family: ${({ theme }) => getFontFamily(theme)};
        color: ${({ theme }) => theme.colors.black};
    }
    .bold {
        font-family: ${({ theme }) => getBoldFontFamily(theme)};
        font-weight: 600;
    }
`

export default GlobalStyle
